import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PropertyService } from 'src/app/_shared/service/property.service';
import { ReportsService } from 'src/app/reports/reports.service';
import { environment } from 'src/environments/environment';
import { CmaState } from '../cma.state';

@Component({
  selector: 'app-property-search-list',
  templateUrl: './property-search-list.component.html',
  styleUrls: ['./property-search-list.component.scss'],
})
export class PropertySearchListComponent implements OnInit {
  @ViewChild('listPaginator', { static: false }) listPaginator: MatPaginator;
  @ViewChild('propertyListContainer') propertyListContainer: ElementRef;

  propertyList: Array<any> = [];
  listingImageBaseUrl = environment.listingImageBaseUrl;
  searchPropertyInput: any;
  isStreetViewAvailable = true;
  pageSize: any = 20;
  pageIndex: number = 0;
  streetView: any;
  onDestroyNotifier$ = new Subject();

  constructor(
    private cdr: ChangeDetectorRef,
    public cmaState: CmaState,
    public propertyService: PropertyService,
    public reportsService: ReportsService
  ) {}

  ngOnInit(): void {
    this.cmaState.listPropertySet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      this.propertyList = [];
      if (res && res.length > 0) {
        this.propertyList = res;
      }
      this.cdr.detectChanges();
    });
  }

  ngAfterViewInit(): void {
    this.cmaState.searchAddress$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        let addressObj: any = {
          ...res,
          pagenumber: 1,
          pagesize: 20,
        };
        if (addressObj.SubPremise == null) {
          delete addressObj.SubPremise;
        }
        const isPartialAddress = Object.values(addressObj).some((value) => value === null);
        this.cmaState.listPropertySetCount = null;
        this.pageIndex = 0;
        this.searchPropertyInput = addressObj;
        if (isPartialAddress === true) {
          this.reportsService.searchPropertyDetails(addressObj, 'cma');
        } else {
          const listingObj = {
            streetAddress: `${addressObj.StreetNumber} ${addressObj.StreetName}`,
            city: addressObj.City,
            state: addressObj.State,
            zip: addressObj.Zip,
          };

          this.propertyService.getListingDetailsByCompleteAddress({ address: listingObj }, 'cma').subscribe(
            (res) => {
              if (res && res.PMXPropertyId) {
                this.getDetails(res);
              } else {
                // Complete address search returned no data
                this.reportsService.searchPropertyDetails(addressObj,'cma');
              }
            },
            (err) => {
              console.error('getListingDetailsByCompleteAddress failed:', err);
            }
          );
        }
        // if (isPartialAddress == true) {
        //   this.reportsService.searchPropertyDetails(addressObj, 'cma');
        // } else {
        //   let listingObj = {
        //     streetAddress: addressObj.StreetNumber + ' ' + addressObj.StreetName,
        //     city: addressObj.City,
        //     state: addressObj.State,
        //     zip: addressObj.Zip,
        //   }
        //   this.propertyService.getListingDetailsByCompleteAddress({ address: listingObj }, 'cma').subscribe((res) => {
        //     this.getDetails(res)
        //   })
        // }
      }
    });

    this.cmaState.searchPropertyInput.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.searchPropertyInput = res;
        this.pageIndex = 0;
        this.reportsService.searchPropertyDetails(res, 'cma');
      }
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  getDetails(property) {
    this.cmaState.isLoadingCreateReport = true;
    this.cmaState.propertyDetailsCardValue = property;
    this.cmaState.showPropertyDetailsCardValue = true;
    this.cdr.detectChanges();
  }

  onPageChange(event) {
    this.searchPropertyInput.pagenumber = event.pageIndex + 1;
    this.reportsService.searchPropertyDetails(this.searchPropertyInput, 'cma');
  }

  calculateDateDifference(date1: string): number {
    const parsedDate1 = new Date(date1);
    const parsedDate2 = new Date();

    const differenceInMs = Math.abs(parsedDate1.getTime() - parsedDate2.getTime());
    const differenceInDays = differenceInMs / (1000 * 3600 * 24);

    return differenceInDays;
  }

  onStreetViewAvailable(isAvailable: boolean) {
    this.isStreetViewAvailable = isAvailable;
  }

  setStreetView(event: any) {
    this.streetView = event;
  }

  getDefaultPlace(property: any) {
    const lat = Number(property?.Latitude);
    const lng = Number(property?.Longitude);
    return !isNaN(lat) && !isNaN(lng) ? { lat, lng } : { lat: '', lng: '' };
  }

  shouldShowStreetView(property) {
    return !property?.ImageURLs && !property?.ListingId;
  }
}
